import { ExamEventStatusButtonGroup } from '@exam-center/exam-event-management';
import { type ExamEventStatus } from '@exam-center/graphql';
import {
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useExamEventScheduleSearchParams } from '../../hooks';
import { ExamEventScheduleFilters } from '../exam-event-schedule-filters';

export default function ExamEventScheduleFiltersGroup() {
  const [{ status }, { changeStatus }] = useExamEventScheduleSearchParams();

  const [isExpand, { toggle }] = useDisclosure(false);

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <ExamEventStatusButtonGroup
          value={status as 'ALL' | ExamEventStatus}
          onChange={(value) => changeStatus(value === 'ALL' ? null : value)}
        />
        <Button
          variant='outlined'
          color='secondary'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ExamEventScheduleFilters />
      </Collapse>
    </>
  );
}
